// Slider configuration constants
export const SLIDER_CONFIG = {
  MIN_PERCENT: 0,
  MAX_PERCENT: 105,
  STEP: 0.1,
  VISUAL_MAX_PERCENT: 100, // For visual display normalization
}

export default SLIDER_CONFIG
